import { getCookie, setCookie } from './cookies';
const TEST_STRING = '00test00';
let hasFormTest = false;
export const detectFormTest = (data) => {
    if (hasFormTest) {
        return true;
    }
    if (getCookie('internalTest')) {
        hasFormTest = true;
        return true;
    }
    for (const key in data) {
        if (typeof data[key] === 'string' && data[key].toLowerCase().includes(TEST_STRING)) {
            hasFormTest = true;
            setCookie('internalTest', 'true', { 'max-age': 31536000 });
            return true;
        }
    }
    return false;
};
export const findTestFormField = () => {
    const allFormInputs = document.querySelectorAll('input[type="text"], input[type="email"], input:not([type])');
    for (let formInput of allFormInputs) {
        if (formInput.value.toLowerCase().includes(TEST_STRING)) {
            return formInput;
        }
    }
    return null;
};
